var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.591,
    height: 57.474,
    viewBox: "0 0 57.591 57.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 57.591,
    height: 57.474,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M6.544,9.722a.656.656,0,0,1-.46-.19L.19,3.639a.655.655,0,0,1,0-.923L2.719.19a.652.652,0,0,1,.922,0L9.531,6.082a.65.65,0,0,1,0,.922L7.005,9.531a.656.656,0,0,1-.461.19M1.573,3.178l4.97,4.97L8.149,6.542,3.179,1.573Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M8.316,14.989a.65.65,0,0,1-.46-.19L3.37,10.314a.655.655,0,0,1,0-.923L9.394,3.371a.65.65,0,0,1,.922,0L14.8,7.855a.652.652,0,0,1,0,.922L8.777,14.8a.651.651,0,0,1-.461.19M4.753,9.853l3.562,3.562,5.1-5.1L9.854,4.752Z",
    transform: "translate(0.965 0.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M18.122,15.066a.651.651,0,0,1-.46-.192l-4.484-4.483a.652.652,0,0,1,0-.922L19.2,3.447a.672.672,0,0,1,.922,0l4.484,4.485a.65.65,0,0,1,0,.922l-6.022,6.021a.652.652,0,0,1-.461.192M14.56,9.93l3.561,3.562,5.1-5.1L19.66,4.83Z",
    transform: "translate(3.941 0.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M9.066,17.855a.649.649,0,0,1-.461-.19l-1.96-1.959a.655.655,0,0,1,0-.923L20.34,1.088a.652.652,0,0,1,.922,0l1.959,1.959a.65.65,0,0,1,0,.922L9.526,17.665a.644.644,0,0,1-.46.19M8.027,15.244l1.039,1.038L21.839,3.509,20.8,2.471Z",
    transform: "translate(1.959 0.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M14.009,22.8a.649.649,0,0,1-.461-.19l-1.96-1.959a.655.655,0,0,1,0-.923l13.7-13.695a.652.652,0,0,1,.922,0l1.959,1.959a.65.65,0,0,1,0,.922l-13.695,13.7a.644.644,0,0,1-.46.19M12.97,20.188l1.039,1.038L26.782,8.453,25.745,7.415Z",
    transform: "translate(3.459 1.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M18.526,34.439a.652.652,0,0,1-.46-.19L13.58,29.764a.655.655,0,0,1,0-.923L19.6,22.819a.652.652,0,0,1,.922,0L25.009,27.3a.65.65,0,0,1,0,.922l-6.022,6.022a.655.655,0,0,1-.461.19M14.963,29.3l3.562,3.562,5.1-5.1L20.064,24.2Z",
    transform: "translate(4.064 6.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M18.2,24.949a.649.649,0,0,1-.461-.19l-4.485-4.484a.655.655,0,0,1,0-.923L19.6,13.013a.651.651,0,0,1,.923,0L25,17.5a.65.65,0,0,1,0,.922l-6.338,6.34a.653.653,0,0,1-.461.19m-3.562-5.136L18.2,23.375l5.417-5.419-3.561-3.562Z",
    transform: "translate(3.966 3.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M13.835,32.86h0a.651.651,0,0,1-.461-.19l-1.959-1.959a.654.654,0,0,1,0-.923L25.109,16.093a.652.652,0,0,1,.922,0l1.96,1.959a.65.65,0,0,1,0,.922L14.3,32.67a.646.646,0,0,1-.46.19M12.8,30.249l1.038,1.038L26.609,18.514,25.57,17.476Z",
    transform: "translate(3.406 4.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M37.976,44.649a.644.644,0,0,1-.46-.19L33.03,39.974a.655.655,0,0,1,0-.923l6.023-6.021a.65.65,0,0,1,.922,0l4.484,4.484a.65.65,0,0,1,0,.922l-6.022,6.022a.649.649,0,0,1-.461.19m-3.562-5.136,3.562,3.562,5.1-5.1-3.562-3.564Z",
    transform: "translate(9.967 9.967)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M37.9,34.841h0a.651.651,0,0,1-.46-.192l-4.484-4.484a.654.654,0,0,1,0-.923l6.022-6.022a.672.672,0,0,1,.922,0l4.484,4.485a.652.652,0,0,1,0,.922L38.357,34.65a.652.652,0,0,1-.461.192M34.334,29.7,37.9,33.267l5.1-5.1L39.434,24.6Z",
    transform: "translate(9.943 6.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M33.783,42.572h0a.651.651,0,0,1-.461-.19l-1.959-1.959a.654.654,0,0,1,0-.923L45.057,25.805a.652.652,0,0,1,.922,0l1.96,1.959a.65.65,0,0,1,0,.922l-13.7,13.7a.646.646,0,0,1-.46.19m-1.038-2.611L33.783,41,46.557,28.226l-1.039-1.038Z",
    transform: "translate(9.461 7.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M38.2,46.671h0a.651.651,0,0,1-.461-.19l-1.959-1.959a.654.654,0,0,1,0-.923L43.6,35.78a.655.655,0,0,1,.923,0l1.958,1.96a.65.65,0,0,1,0,.922l-7.818,7.818a.646.646,0,0,1-.46.19M37.164,44.06,38.2,45.1l6.9-6.9-1.038-1.038Z",
    transform: "translate(10.802 10.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M28.84,37.627h0a.651.651,0,0,1-.461-.19l-1.959-1.96a.652.652,0,0,1,0-.922L40.114,20.861a.672.672,0,0,1,.922,0l1.959,1.959a.65.65,0,0,1,0,.922L29.3,37.437a.646.646,0,0,1-.46.19M27.8,35.017l1.038,1.038L41.613,23.281l-1.038-1.038Z",
    transform: "translate(7.96 6.276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M28.089,34.837a.651.651,0,0,1-.46-.192l-4.485-4.484a.655.655,0,0,1,0-.923L29.485,22.9a.65.65,0,0,1,.922,0l4.483,4.484a.652.652,0,0,1,0,.922l-6.339,6.34a.652.652,0,0,1-.461.192M24.526,29.7l3.562,3.562,5.419-5.419-3.562-3.562Z",
    transform: "translate(6.966 6.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M18.778,37.8h0a.651.651,0,0,1-.461-.19l-1.958-1.959a.651.651,0,0,1,0-.923L30.052,21.036a.652.652,0,0,1,.922,0L32.934,23a.65.65,0,0,1,0,.922l-13.695,13.7a.651.651,0,0,1-.461.19M17.74,35.192l1.038,1.038L31.552,23.457l-1.039-1.038Z",
    transform: "translate(4.907 6.327)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.710e64928ef9d86301011e38f0bdeb21.svg";
export { ForwardRef as ReactComponent };